export enum AppEventType {
  SENDED_ROOM_CHAT_MESSAGE = 'SENDED_ROOM_CHAT_MESSAGE',
  SENDED_USER_CHAT_MESSAGE = 'SENDED_USER_CHAT_MESSAGE',
  FORWARD_TO_ROOM = 'FORWARD_TO_ROOM',
  FORWARD_MESSAGE_TO_ROOM = 'FORWARD_MESSAGE_TO_ROOM',
  ARQUIVE_ROOM_MENU_PANEL = 'ARQUIVE_ROOM_MENU_PANEL',
}
